<script lang="ts">
  import { Form } from "../lib/validation_next";

  export let onClicked: ((shiftPressed: boolean) => void) | undefined =
    undefined;
  export let disabled = false;
  export let label = "";
  export let customClass = "";
  export let name = "";
  export let field: Form.Checkbox<any> | Form.Toggle<any>;

  let value = field.input;

  const clicked = (e: MouseEvent) => {
    e.stopPropagation();
    document.getSelection()?.removeAllRanges();
    if (onClicked) {
      onClicked(e.getModifierState("Shift"));
    }
  };
</script>

<div
  class:disabled
  class="flex items-center {customClass}"
>
  <input
    type="checkbox"
    {name}
    id={name}
    bind:checked={$value}
    on:click={clicked}
    {disabled}
    class="custom-checkbox peer"
    class:disabled
  />
  <svg
    class="custom-checkmark"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="20 6 10 20 4 12"></polyline>
  </svg>

  <label
    class:disabled
    class="label ml-2 select-none cursor-pointer"
    for={name}
  >
    {label}<slot />
  </label>
</div>

<style lang="postcss">
  .custom-checkbox {
    @apply h-[24px] w-[24px] min-w-[24px] rounded-[5px] focus:outline-none
      border-[2px] cursor-pointer bg-transparent text-transparent
      border-greenGrey-10 accent-green-45 appearance-none bg-white;
  }
  .custom-checkbox:hover {
    @apply ring-0 ring-offset-0;
  }
  .custom-checkbox:hover {
    @apply border-[#a4baba];
  }
  .custom-checkbox:checked {
    @apply bg-green-45 border-green-45;
  }
  .custom-checkbox.disabled {
    @apply bg-grey-20 border-grey-20 cursor-default;
  }

  label.disabled {
    @apply text-grey-20 cursor-default;
  }
  .custom-checkmark {
    @apply absolute w-[16px] h-[16px] ml-[4px] hidden peer-checked:block
      pointer-events-none;
  }
</style>
